<template>
  <div class="content-center bg-black">
    <div style="background-color: #cc007a">
      <div class="p-7 flex justify-center items-center">
        <a href="/"><img src="/images/logo_testo.png" /></a>
      </div>
      <div style="padding: 50px 20px" class="p-2 flex justify-center items-center">
        <span class="text-white text-center font-bold text-3xl">Conserva questo codice coupon<br> effettuando uno screenshot e <br>vieni a trovarci <br>per ricevere uno <br>sconto! </span>
        <!-- <span class="text-white text-center font-bold text-4xl"><br>Complimenti!<br><br>La tua registrazione è <br>andata a buon fine.<br><br> Continua a seguirci <br>anche sui social <br>per non perdere i nostri <br>prossimi eventi <br>ricchi di sconti! <br><br><br><br><br> </span> -->
      </div>
      <div class="p-2 flex justify-center items-center">
        <vue-barcode style="padding: 50px 20px" v-bind:value="'NEWSLETTER'" :options="{ displayValue: true }"></vue-barcode>
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'

export default {
  components: {
    VueBarcode,
  },
  data() {
    return {
      options: {},
    }
  },
}
</script>